
import { controls } from "../../controls";

const ms204 = {
  label: "Freeze Account",
  pageLabel: "Freeze Account",
  starting: true,
  url: "ms204",
  pageType: "history",
  form: [
    ...controls.displayText({ tab: "filter", label: "Account No", width: "col-sm-1" }),
    ...controls.AccountNumber({
      tab: "filter", forceRender:true,
      beforeLeave:["createAcNo"],
    }),
    ...controls.showData({ tab: "filter", data: "account_number_display", width: "col-sm-2" }),

    ...controls.magicDateLabel({ tab: "create",  label: "Freeze Date", width: "col-sm-1" }),
    ...controls.magicDate({ dateType:"ontype",default:"sessiondate", name: "freeze_date",width:"col-sm-2"}),
    
    ...controls.radio({ tab: "filter", width: "col-sm-4", name: "isFreeze", cwidth: "col-sm-6", options: [{ label: "Freeze Account", value: "freezeaccount" },    { label: "UnFreeze Account", value: "Unfreezeaccount" }], clearChildren: [{}] }),

    ...controls.displayText({ tab: "filter", label: "Freeze", width: "col-sm-1" }),
    ...controls.FreezeTypes({ tab: "filter", width: "col-sm-2" }),
    ...controls.displayText({tab:"Modal",label: "",width:"col-sm-2"}),

    ...controls.displayText({tab:"Modal",label: "Reason",width:"col-sm-1"}),
    ...controls.Reason({tab: "Modal"}),
    ...controls.showData({tab:"Modal",data: "reason_display", name: "reason_display",width:"col-sm-4"}),


    ...controls.displayText({ tab: "Modal", label: "Description", width: "col-sm-1" }),
    ...controls.text({ tab: "Modal", name: "description", width: "col-sm-4", placeHolder: "Description" }),
    // ...controls.displayText({ tab: "Modal", label: "", width: "col-sm-6" }),

    ...controls.displayText({ tab: "Modal", label: "Remark", width: "col-sm-1" }),
    ...controls.text({ tab: "Modal", name: "remark", width: "col-sm-4", placeHolder: "Unfreeze remark" }),
    ...controls.displayText({ tab: "Modal", label: "", width: "col-sm-2" }),

    ...controls.displayText({ style: { textAlign: 'right' }, tab: "filter", label: "Amount", width: "col-sm-1" }),
    ...controls.numtoword({
      tab: "filter", convertedTo: "entered_amount_text", name: "amount", width: "col-sm-2",
    }),
    ...controls.showData({
      tab: "filter", data: "entered_amount_text", name: "entered_amount_text", width: "col-sm-9", style: { fontSize: 14 },
    }),

    
  ]
};

export default ms204;
